import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';
import PaymentStatusStore from '../../stores/PaymentStatusStore';
import AccountsStore from '../../stores/AccountsStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import StepHeader from '../../includes/StepHeader';
import ViewPaymentHistory from './ViewPaymentHistory';
import AccountDropDownComponent from './AccountDropDownComponent';
import PaymentHistoryListDesktop from './PaymentHistoryListDesktop';
import PaymentHistoryListMobile from './PaymentHistoryListMobile';
import Filter from './Filter';
import StringConstant from '../../constants/StringConstants';
import {
  getPaymentHistory,
  fetchMorePaymentHistory,
  getPaymentStatusData,
} from '../../actions/PaymentStatusActionCreator';
import { ToolTipComponent } from '../common/ToolTipComponent';
import { dateIntervalOptions } from './PaymentHistoryHelper';
import SvgIcon from '../common/SvgIcon';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import ApiUtils from '../../utils/ApiUtils';
import PaymentStatusHomeSME from './sme/PaymentStatusHomeSME';
import { handleChooseAccountFromPicker } from '../../utils/PaymentStatusUtils';
import { BioCatchContext } from '../BioCatchContext';
import { VIEW_PAYMENT_DETAILS_CONTEXT } from '../../config/BioCatch';

let fromChangeOfDate = false;
let changeOfDate = false;
const defaultStartDate = moment().subtract(3, 'months').startOf('days');
const defaultEndDate = moment().endOf('days');
const CAPABILTY_TRANSACTION_READ = '/account/transactions/read';
class PaymentStatusList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountList: AccountsStore.getAllCapableAccounts(
        CAPABILTY_TRANSACTION_READ
      ),
      showPaymentHistoryList: true,
      selectedPaymentHistory: null,
      paymentHistoryList: [],
      selectedAccount: null,
      showMore: PaymentStatusStore.isShowMore(),
      startDate: moment().subtract(3, 'months').startOf('day'),
      endDate: moment().endOf('day'),
      customDateSelected: PaymentStatusStore.getCustomDateSelected(),
      monthName: PaymentStatusStore.getMonthName(),
      refreshError: false,
      isLoading: PaymentStatusStore.isLoading(),
      isFetchingMore: PaymentStatusStore.isFetchingMore(),
      hasError: PaymentStatusStore.hasError(),
      showAccountPicker: false,
    };
    this.setRequestPacket();
    const selectedAccountId = PaymentStatusStore.getSelectedAccountId();
    if (selectedAccountId) {
      const accountIds = [];
      const selectedAccount = AccountsStore.getAccountDetail(selectedAccountId);
      this.state.selectedAccount = selectedAccount;
      accountIds.push(selectedAccountId);
      this.state.params.params.account_list = accountIds;
      getPaymentHistory(this.state.params);
    }
    this.onStoreChange = this.onStoreChange.bind(this);
    this.renderPaymentHistoryListDesktop =
      this.renderPaymentHistoryListDesktop.bind(this);
    this.renderPaymentHistoryListMobile =
      this.renderPaymentHistoryListMobile.bind(this);
    this.navigateBack = this.navigateBack.bind(this);
    this.viewStatus = this.viewStatus.bind(this);
    this.onDropdownSelect = this.onDropdownSelect.bind(this);
    this.showPaymentHistory = this.showPaymentHistory.bind(this);
    this.loadMorePaymentList = this.loadMorePaymentList.bind(this);
    this.sortTransacations = this.sortTransacations.bind(this);
    this.settingMonthName = this.settingMonthName.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.settingFromDate = this.settingFromDate.bind(this);
    this.settingToDate = this.settingToDate.bind(this);
    this.reloadData = this.reloadData.bind(this);
    this.setCustomDateSelected = this.setCustomDateSelected.bind(this);
    this.refreshErrorReset = this.refreshErrorReset.bind(this);
    this.renderSMEPaymentHistory = this.renderSMEPaymentHistory.bind(this);
    this.renderRetailHistory = this.renderRetailHistory.bind(this);
  }
  componentWillMount() {
    PaymentStatusStore.addChangeListener(this.onStoreChange);
    if (PaymentStatusStore.getPaymentStatusList() === null) {
      getPaymentStatusData();
    }
  }
  componentWillUnmount() {
    PaymentStatusStore.setSelectedAccountId();
    PaymentStatusStore.resetMoveMoneyUrl();
    PaymentStatusStore.reset();
    PaymentStatusStore.removeChangeListener(this.onStoreChange);
  }
  onDateChange(startDate, endDate) {
    const newStartDate = moment(startDate).startOf('day').toISOString();
    const newEndDate = moment(endDate).endOf('day').toISOString();
    const { params } = this.state;
    params.params.from = StringConstant.TRANSACTION_INITIAL_VALUE;
    params.params.to = StringConstant.TRANSACTION_LIMIT;
    params.params.start_date = newStartDate;
    params.params.end_date = newEndDate;
    this.setState({ startDate, endDate, accountChangeFlag: false });
    changeOfDate = false;
    this.state.params = params;
    getPaymentHistory(this.state.params);
  }
  onDropdownSelect(selectedKey) {
    PaymentStatusStore.reset();
    this.setState({ refreshError: true });
    const accountIds = [];
    if (selectedKey === StringConstant.ALL) {
      this.setState({
        selectedAccount: selectedKey,
      });
      map(this.state.accountList, (account) => {
        accountIds.push(account.id);
        return true;
      });
    } else {
      const selectedAccount = AccountsStore.getAccountDetail(selectedKey);
      this.setState({
        selectedAccount,
      });
      accountIds.push(selectedKey);
    }
    this.setState({
      startDate: defaultStartDate,
      endDate: defaultEndDate,
    });
    const { params } = this.state;
    params.params.from = StringConstant.TRANSACTION_INITIAL_VALUE;
    params.params.to = StringConstant.TRANSACTION_LIMIT;
    params.params.account_list = accountIds;
    params.params.start_date = defaultStartDate.toISOString();
    params.params.end_date = defaultEndDate.toISOString();
    getPaymentHistory(params);
  }
  onStoreChange() {
    this.setState({
      paymentHistoryList: PaymentStatusStore.getPaymentHistoryList(),
      showMore: PaymentStatusStore.isShowMore(),
      hasError: PaymentStatusStore.hasError(),
      isLoading: PaymentStatusStore.isLoading(),
      isFetchingMore: PaymentStatusStore.isFetchingMore(),
      customDateSelected: PaymentStatusStore.getCustomDateSelected(),
      monthName: PaymentStatusStore.getMonthName(),
    });
  }
  getSessionData() {
    const { session } = this.props;
    return {
      clientContext: ApiUtils.getApiClientContext(),
      accessToken: session.accessToken,
      bankId: ApiUtils.getBankId(),
    };
  }
  getSortName(name) {
    const sortName = {
      createdDate: 'when',
      fromAccountName: 'from',
      toAccountName: 'to',
    };
    return sortName[name];
  }
  setCustomDateSelected(isCustomDate) {
    this.setState({ customDateSelected: isCustomDate });
  }
  setRequestPacket() {
    const params = {
      params: {
        from: StringConstant.TRANSACTION_INITIAL_VALUE,
        to: StringConstant.TRANSACTION_LIMIT,
        start_date: defaultStartDate.toISOString(),
        end_date: defaultEndDate.toISOString(),
        sort_field: 'details.when',
        order: 'desc',
      },
    };
    this.state.params = params;
  }
  settingFromDate(fromDate) {
    if (this.state.startDate !== fromDate) {
      fromChangeOfDate = true;
      this.setState({ startDate: fromDate, changeOfDate: true });
    } else {
      fromChangeOfDate = false;
      this.setState({ changeOfDate: false });
    }
  }
  settingMonthName(_monthName) {
    this.setState({ monthName: _monthName });
  }
  settingToDate(toDate) {
    if (
      fromChangeOfDate ||
      moment(this.state.endDate).startOf('day').toISOString() !==
        moment(toDate).startOf('day').toISOString()
    ) {
      changeOfDate = true;
      this.setState({ endDate: toDate, changeOfDate: true });
    } else {
      changeOfDate = false;
      this.setState({ changeOfDate: false });
    }
  }
  filterTransactions(startDate, endDate) {
    const { params } = this.state;
    params.params.from = StringConstant.TRANSACTION_INITIAL_VALUE;
    params.params.to = StringConstant.TRANSACTION_LIMIT;
    params.params.start_date = startDate.startOf('days').toISOString();
    params.params.end_date = endDate.endOf('days').toISOString();
    this.state.params = params;
  }
  handleRoute(route) {
    InternetBankingActions.navigateToWebTask(route);
  }
  loadMorePaymentList() {
    const { params } = this.state;
    params.params.from += StringConstant.TRANSACTION_LIMIT;
    params.params.to += StringConstant.TRANSACTION_LIMIT;
    this.state.params = params;
    fetchMorePaymentHistory(this.state.params);
  }
  navigateBack() {
    const backUrl = PaymentStatusStore.getBackUrl();
    InternetBankingActions.navigateToWebTask(backUrl);
  }
  refreshErrorReset() {
    this.setState({ refreshError: false });
  }

  reloadData() {
    getPaymentHistory(this.state.params);
  }
  showPaymentHistory() {
    this.setState({
      showPaymentHistoryList: true,
    });
  }
  sortTransacations(columnName, sortingOrder) {
    let sortingName = 'details.';
    const name = this.getSortName(columnName);
    sortingName = `${sortingName}${name}`;
    const { params } = this.state;
    params.params.order = sortingOrder;
    params.params.from = StringConstant.TRANSACTION_INITIAL_VALUE;
    params.params.to = StringConstant.TRANSACTION_LIMIT;
    params.params.sort_field = sortingName;
    this.state.params = params;
    getPaymentHistory(this.state.params);
  }
  viewStatus(rowData) {
    this.setState({
      showPaymentHistoryList: false,
      selectedPaymentHistory: rowData,
    });
  }
  renderPaymentHistoryDetails() {
    return (
      <ViewPaymentHistory
        paymentHistoryDetails={this.state.selectedPaymentHistory}
        goBack={this.showPaymentHistory}
      />
    );
  }
  renderPaymentHistoryList() {
    const svgimage = (
      <a
        href="javascript:;"
        className="tooltip-icon"
        aria-label="Information"
        role="button"
      >
        <SvgIcon id="icon-Information" width="24px" height="24px" />
      </a>
    );
    return (
      <div>
        <section className="u-flex payment-history-header">
          <h2 className="header-title">
            {this.props.content.paymentHistoryListHeader}&nbsp;
          </h2>
          <div className="header__info-icon">
            <ToolTipComponent
              className="info-icon"
              hasSvg
              trigger="manual"
              childComponent={svgimage}
              placement="bottom"
              popoverChildComponent={
                <p
                  dangerouslySetInnerHTML={{
                    __html: this.props.content.paymentHistoryToolTipMessage,
                  }}
                />
              }
            />
          </div>
        </section>
        <div className="payment-history">
          <section className="payment-history-filter">
            {this.props.browserView <= StringConstant.VIEW_TABLET ? (
              ''
            ) : (
              <Filter
                filterTransactions={this.filterTransactions}
                dateIntervalOptions={dateIntervalOptions}
                onDateChange={this.onDateChange}
                startDate={this.state.startDate}
                settingMonthName={this.settingMonthName}
                monthName={this.state.monthName}
                endDate={this.state.endDate}
                fromChangeOfDate={fromChangeOfDate}
                settingFromDate={this.settingFromDate}
                settingToDate={this.settingToDate}
                changeOfDate={changeOfDate}
                content={this.props.content}
                customDateSelected={this.state.customDateSelected}
                setCustomDateSelected={this.setCustomDateSelected}
                refreshError={this.state.refreshError}
                refreshErrorReset={this.refreshErrorReset}
              />
            )}
          </section>
          <section className="payment-history-grid">
            {this.props.browserView <= StringConstant.VIEW_TABLET
              ? this.renderPaymentHistoryListMobile()
              : this.renderPaymentHistoryListDesktop()}
          </section>
        </div>
      </div>
    );
  }
  renderPaymentHistoryListDesktop() {
    return (
      <PaymentHistoryListDesktop
        {...this.props}
        {...this.state}
        sortTransacations={this.sortTransacations}
        onCustomClick={this.viewStatus}
        loadMorePaymentHistory={this.loadMorePaymentHistory}
        filterTransactions={this.filterTransactions}
        loadMorePaymentList={this.loadMorePaymentList}
        clickToReload={this.reloadData}
      />
    );
  }
  renderPaymentHistoryListMobile() {
    const {
      paymentHistoryList,
      isLoading,
      showMore,
      isFetchingMore,
      hasError,
    } = this.state;
    return (
      <PaymentHistoryListMobile
        {...this.props}
        paymentHistoryList={paymentHistoryList}
        hasError={hasError}
        isFetching={isLoading}
        showMore={showMore}
        isFetchingMore={isFetchingMore}
        loadMorePaymentList={this.loadMorePaymentList}
        onCustomClick={this.viewStatus}
        clickToReload={this.reloadData}
      />
    );
  }
  renderRetailHistory() {
    const { accountList, selectedAccount } = this.state;
    return (
      <div>
        <StepHeader
          onClick={this.navigateBack}
          headerCrumbsMessage="Back"
          headerTitle={'Payment status and history'}
          headerSubtext={
            'Keep track of payments you’ve made within mobile and internet banking.'
          }
          showheaderCrumbs
        />
        <div className="c-field">
          <label className="c-field__label" htmlFor="dropdown-custom-menu">
            Account
          </label>
          <div className="c-field__controls">
            <AccountDropDownComponent
              selectedAccount={selectedAccount}
              accountList={accountList}
              onDropdownSelect={this.onDropdownSelect}
            />
          </div>
        </div>
        {selectedAccount && this.renderPaymentHistoryList()}
      </div>
    );
  }

  renderSMEPaymentHistory() {
    return (
      <PaymentStatusHomeSME
        content={this.props.content}
        handleRoute={this.handleRoute}
        handleBack={this.navigateBack}
        session={this.getSessionData()}
        onShowAccountPicker={handleChooseAccountFromPicker}
      />
    );
  }

  render() {
    const { showPaymentHistoryList } = this.state;
    return (
      <BioCatchContext context={VIEW_PAYMENT_DETAILS_CONTEXT}>
        <div className="bow page">
          <Helmet title="Payment status and history" />
          <div
            className="container manage-payment-history"
            id="site-main"
            role="main"
            tabIndex="-1"
          >
            {!showPaymentHistoryList && (
              <div className="row">
                <div className="col-sm1-24">
                  {this.renderPaymentHistoryDetails()}
                </div>
              </div>
            )}
            {showPaymentHistoryList &&
              (this.props.isSMEUser
                ? this.renderSMEPaymentHistory()
                : this.renderRetailHistory())}
          </div>
        </div>
      </BioCatchContext>
    );
  }
}
PaymentStatusList.propTypes = {
  content: PropTypes.object,
  browserView: PropTypes.number,
  isSMEUser: PropTypes.bool.isRequired,
  session: PropTypes.shape({
    accessToken: PropTypes.string.isRequired,
  }).isRequired,
};

PaymentStatusList.defaultProps = {
  content: {},
  browserView: 2,
};
export default RequiresAuthenticatedUser(PaymentStatusList);
